import React from "react";

interface CreateSetupButtonProps {
  onCreateSetup: () => void;
  visible: boolean;
}

const CreateSetupButton: React.FC<CreateSetupButtonProps> = ({
  onCreateSetup,
  visible,
}) => {
  if (!visible) return null;

  return (
    <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2">
      <button
        type="button"
        onClick={onCreateSetup}
        className="bg-white text-black px-6 py-3 rounded-full font-medium shadow-lg"
      >
        <div className="flex items-center justify-center">
          <div className="text-sm">🤩 Confirm this setup</div>
        </div>
      </button>
    </div>
  );
};

export default CreateSetupButton;
